
export const data = {
      info: {
            name: "Set your name",
            id_xat: "Set your id xat",
            status: 'Set your status',
            location: "xat.com",
            avatar: "https://i.postimg.cc/zX6Q3yZj/no-user.jpg",
            about: "Write a little bit about yourself",
            me: "https://xat.com/editme"
      },
      relation: {
            name: "Set relationship name",
            id_xat: "Set relationship id xat",
            avatar: "https://i.postimg.cc/zX6Q3yZj/no-user.jpg",
            about: "Write a little bit about relationship",
            me: "https://xat.com/editme",
            love_count: "Set your romance time"
      },
      banner: {
            image: "https://i.postimg.cc/08xg0Jgv/banner-bg.jpg",
            title: "Please define a title and choose an image to use as a banner"
      },
      social: {
            facebook: "https://www.facebook.com",
            twitter: "https://www.facebook.com",
            instagram: "https://www.facebook.com",
            youtube: "https://www.facebook.com",
            tumblr: "https://www.tumblr.com",
            tiktok: "https://www.tiktok.com",
            discord: "https://www.discord.com"
      },
      galleries: {
            img: "https://i.postimg.cc/Rhfxcr48/banner.jpg"
      }
}


export function getAvatar(name){

      return `https://api.dicebear.com/5.x/initials/svg?seed=${name}&fontSize=26`
}